module.exports = __webpack_public_path__ + "img/icon2.293d8ab8.png";